var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('loading'):_vm._e(),(!_vm.loading)?_c('vue-apex-charts',{attrs:{"type":"bar","height":"400","options":_vm.chartOptions,"series":_vm.series}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }